/* eslint-disable arrow-body-style */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import './MappedCodesDetail.css';

const MappedCodesDetail = ({ data }) => {
  const { rowData } = data;
  const rowTitle = rowData.CodeMappingType === 'Schedule' ? 'WFM Tool' : 'Detail';
  return (
    <div className='details__wrapper'>
      <div className='details__container'>
        <p className='details__title'>Mapped codes</p>
        {
          rowData && rowData.avaliblesCodes.map(code => (
            <p key={code.mappingKey}>{code.MappedCode}</p>
          ))
        }
      </div>
      <div className='details__container' >
        <p className='details__title'>{rowTitle}</p>
        {
          rowData && rowData.avaliblesCodes.map(code => (
            <p key={code.mappingKey}>{code.Detail}</p>
          ))
        }
      </div>
    </div>
  )
};

MappedCodesDetail.propTypes = {
  data: PropTypes.object.isRequired,
};

export default MappedCodesDetail
